<template>
  <div v-if="invoiceDialog">
    <el-drawer
      title="填写预计时间"
      :visible.sync="drawerDialog"
      :direction="direction"
      @close="close"
      ref="drawer"
    >
      <el-form
        ref="makeInvoiceForm"
        :model="invoiceData"
        label-width="80px"
        label-position="top"
        :rules="rules"
      >
        <el-form-item
          label="预计交付时间"
          prop="estimated_time"
        >
          <div class="gray">
            {{estimatedDeliveryTime}}
          </div>
        </el-form-item>
        <el-form-item label="是否为多笔回款订单">
          <el-radio-group
            v-model="invoiceRadio"
            @change="changeRadio"
          >
            <el-radio-button label="single">否</el-radio-button>
            <el-radio-button label="More">是</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div v-if="invoiceRadio === 'single'">
          <el-radio-group
            v-model="invoiceDate"
            @change="changeinvoiceDate"
          >
            <el-radio label="time">选择时间</el-radio>
            <el-radio label="day">根据预计交付日期</el-radio>
          </el-radio-group>
          <div v-show="invoiceDate === 'time'">
            <el-form-item
              label="预计开票时间"
              prop="invoiceTime"
            >
              <el-date-picker
                type="date"
                v-model="invoiceData.invoiceTime"
                :picker-options="datePickOptions"
                placeholder="选择时间"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              label="预计收款时间"
              prop="collectionTime"
            >
              <el-date-picker
                type="date"
                v-model="invoiceData.collectionTime"
                :picker-options="datePickOptions"
                placeholder="选择时间"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div v-show="invoiceDate === 'day'">
            <el-form-item
              label="预计验收后"
              prop="invoiceDelta"
            >
              <el-input
                type="number"
                v-model="invoiceData.invoiceDelta"
                placeholder="请输入天数"
                class="inputClass"
              ></el-input> 天 开票
            </el-form-item>
            <el-form-item
              label="预计验收后"
              prop="collectionDelta"
            >
              <el-input
                type="number"
                v-model="invoiceData.collectionDelta"
                placeholder="请输入天数"
                class="inputClass"
              ></el-input> 天 收款
            </el-form-item>
          </div>

        </div>
        <div v-else>
          <div
            v-for="(item,index) in returnedMoneyList"
            :key="index"
          >
            <div>{{item.name}}</div>
            <el-form-item
              label="预计开票时间"
              :prop="item.invoiceTime"
            >
              <el-date-picker
                type="date"
                @blur='changeInvoiceTime'
                v-model="invoiceData[item.invoiceTime]"
                :picker-options="datePickOptions"
                placeholder="选择时间"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              label="预计收款时间"
              :prop="item.collectionTime"
            >
              <el-date-picker
                type="date"
                @blur='changeInvoiceTime'
                v-model="invoiceData[item.collectionTime]"
                :picker-options="datePickOptions"
                placeholder="选择时间"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              label="回款金额（万元）"
              :prop="item.amount"
            >
              <el-input
                type="number"
                v-model="invoiceData[item.amount]"
                placeholder="请输入金额"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            @click="onSubmit"
          >提交</el-button>
          <el-button
            @click="closeDrawer"
            :loading="loading"
          >取消</el-button>
        </el-form-item>
      </el-form>

    </el-drawer>
  </div>

</template>
<script>
import { parseTime } from '@/utils/util'
import { createEstimatedAdvance } from '@/api/api.js';
export default {
  name: 'makeInvoice',
  props: {
    invoiceDialog: {
      type: Boolean,
      default: false
    },
    advanceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    projectId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      invoiceData: {
        invoiceTime: '',
        collectionTime: '',
        invoiceTimeFirst: '',
        collectionTimeFirst: '',
        amountFirst: 0,
        invoiceTimeSecond: '',
        collectionTimeSecond: '',
        amountSecond: 0,
        invoiceTimeThree: '',
        collectionTimeThree: '',
        amountThree: 0,
      },
      timeType: 'standard',
      estimatedDeliveryTime: '', // 预计交付时间
      loading: false,
      drawerDialog: false,
      formruleType: 'timeRule',
      returnedMoneyList: [
        {
          name: '第一笔',
          invoiceTime: 'invoiceTimeFirst', // 预计开票时间
          collectionTime: 'collectionTimeFirst', // 预计首款时间
          amount: 'amountFirst',//回款金额
        },
        {
          name: '第二笔',
          invoiceTime: 'invoiceTimeSecond', // 预计开票时间
          collectionTime: 'collectionTimeSecond', // 预计首款时间
          amount: 'amountSecond',//回款金额
        },
        {
          name: '第三笔',
          invoiceTime: 'invoiceTimeThree', // 预计开票时间
          collectionTime: 'collectionTimeThree', // 预计首款时间
          amount: 'amountThree',//回款金额
        }
      ],
      direction: 'rtl',
      invoiceRadio: 'single', // 是否为多笔订单 single 单 More 多
      invoiceDate: 'time',  // 选择的时间方式
      rules: {
        invoiceTime: [
          { required: true, message: "请选择预计开票时间" }
        ],
        collectionTime: [
          { required: true, message: "请选择预计收款时间" }
        ],
      },
      datePickOptions: {
        //禁用今天往前的日期
        disabledDate (time) {
          return time.getTime() + 86400 * 1000 < Date.now();
        }
      },
      dataKey: ['invoice_time', 'collection_time', 'amount'],
      formDataKey: ['invoiceTime', 'collectionTime', 'amount'],
      indexKey: ['First', 'Second', 'Three']
    }
  },
  watch: {
    'invoiceDialog': {
      async handler (newVal) {
        if (newVal) {
          this.drawerDialog = true
          this.estimatedDeliveryTime = this.advanceData.estimated_delivery_time
          this.singleAmount = this.advanceData.total_amount
          console.log('advanceData', this.advanceData.estimated_advance)
          if (!this.advanceData.estimated_advance.length) return
          if (this.advanceData.estimated_advance.length > 1) {
            this.formruleType = 'moreRule'
            this.timeType = 'standard'
            this.invoiceRadio = 'More'
            const _that = this
            this.advanceData.estimated_advance.forEach((advance, index) => {
              console.log('advanceadvance', advance)
              _that.formDataKey.forEach((inner, innerIndex) => {
                console.log('innerIndexinnerIndex', innerIndex)
                console.log(_that.dataKey)
                // console.log(dataKey[innerIndex], advance[_that.dataKey[innerIndex]])
                _that.invoiceData[inner + _that.indexKey[index]] = advance[_that.dataKey[innerIndex]]
              })
            })
          } else {
            this.invoiceRadio = 'single'
            this.invoiceDate = this.advanceData.estimated_advance[0].time_type === 'standard' ? 'time' : 'day'
            this.formruleType = this.advanceData.estimated_advance[0].time_type === 'standard' ? 'timeRule' : 'dayRule'
            this.invoiceData.invoiceTime = this.advanceData.estimated_advance[0].invoice_time
            this.invoiceData.collectionTime = this.advanceData.estimated_advance[0].collection_time
            this.invoiceData.invoiceDelta = this.advanceData.estimated_advance[0].invoice_delta
            this.invoiceData.collectionDelta = this.advanceData.estimated_advance[0].collection_delta
            this.timeType = this.advanceData.estimated_advance[0].time_type
          }
          console.log(this.invoiceData)
        }
      },
      deep: true,
      immediate: true
    },
    'formruleType': {
      handler (newVal) {
        console.log('formruleType', newVal)
        if (newVal === 'timeRule') {
          this.timeType = 'standard'
          this.rules = {
            invoiceTime: [
              { required: true, message: "请选择预计开票时间" }
            ],
            collectionTime: [
              { required: true, message: "请选择预计收款时间" }
            ],
          }
        } else if (newVal === 'dayRule') {
          this.timeType = 'delta'
          this.rules = {
            invoiceDelta: [
              { required: true, message: "请输入预计验收后多少天开票" }
            ],
            collectionDelta: [
              { required: true, message: "请输入预计验收后多少天收款" }
            ]
          }
        } else {
          this.timeType = 'standard'
          this.rules = {
            invoiceTimeFirst: [
              { required: true, message: "请选择预计开票时间" }
            ],
            collectionTimeFirst: [
              { required: true, message: "请选择预计收款时间" }
            ],
            amountFirst: [
              { required: true, message: "请选择回款金额" }
            ],
            invoiceTimeSecond: [
              { required: true, message: "请选择预计开票时间" }
            ],
            collectionTimeSecond: [
              { required: true, message: "请选择预计收款时间" }
            ],
            amountSecond: [
              { required: true, message: "请选择回款金额" }
            ],
          }
        }
        this.$forceUpdate()
      }
    },
  },
  methods: {
    close () {
      this.$emit("update:invoiceDialog", false)
    },
    changInpit (value) {
      console.log(value)
    },
    changeInvoiceTime () {
      this.$forceUpdate()
    },
    changeRadio (value) {
      if (value === 'More') {
        this.formruleType = 'moreRule'
      } else {
        if (this.invoiceDate === 'time') {
          this.formruleType = 'timeRule'
        } else {
          this.formruleType = 'dayRule'
        }
      }
    },
    changeinvoiceDate (value) {
      if (value === 'time') {
        this.formruleType = 'timeRule'
      } else {
        this.formruleType = 'dayRule'
      }
    },
    async onSubmit () {
      this.$refs.makeInvoiceForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          const estimatedDeliveryTime = (new Date(this.estimatedDeliveryTime)).getTime()
          let params = {
            project_id: this.projectId,
            time_type: this.timeType,
            infos: []
          }
          if (this.formruleType === 'moreRule') {
            const collectionTimeFirst = typeof this.invoiceData.collectionTimeFirst === 'string' ? (new Date(this.invoiceData.collectionTimeFirst)).getTime() : this.invoiceData.collectionTimeFirst.getTime()
            const collectionTimeSecond = typeof this.invoiceData.collectionTimeSecond === 'string' ? (new Date(this.invoiceData.collectionTimeSecond)).getTime() : this.invoiceData.collectionTimeSecond.getTime()
            const collectionTimeThree = this.invoiceData.collectionTimeThree ? (typeof this.invoiceData.collectionTimeThree === 'string' ? (new Date(this.invoiceData.collectionTimeThree)).getTime() : this.invoiceData.collectionTimeThree.getTime()) : ''
            const invoiceTimeFirst = typeof this.invoiceData.invoiceTimeFirst === 'string' ? (new Date(this.invoiceData.invoiceTimeFirst)).getTime() : this.invoiceData.invoiceTimeFirst.getTime()
            const invoiceTimeSecond = typeof this.invoiceData.invoiceTimeSecond === 'string' ? (new Date(this.invoiceData.invoiceTimeSecond)).getTime() : this.invoiceData.invoiceTimeSecond.getTime()
            const invoiceTimeThree = this.invoiceData.invoiceTimeThree ? (typeof this.invoiceData.invoiceTimeThree === 'string' ? (new Date(this.invoiceData.invoiceTimeThree)).getTime() : this.invoiceData.invoiceTimeThree.getTime()) : ''

            let infos = [{
              invoice_time: parseTime(invoiceTimeFirst, '{y}-{m}-{d}'),
              collection_time: parseTime(collectionTimeFirst, '{y}-{m}-{d}'),
              invoice_delta: Math.round((invoiceTimeFirst - estimatedDeliveryTime) / 86400000),
              collection_delta: Math.round((collectionTimeFirst - estimatedDeliveryTime) / 86400000),
              amount: this.invoiceData.amountFirst
            },
            {
              invoice_time: parseTime(invoiceTimeSecond, '{y}-{m}-{d}'),
              collection_time: parseTime(collectionTimeSecond, '{y}-{m}-{d}'),
              invoice_delta: Math.round((invoiceTimeSecond - estimatedDeliveryTime) / 86400000),
              collection_delta: Math.round((collectionTimeSecond - estimatedDeliveryTime) / 86400000),
              amount: this.invoiceData.amountSecond
            },
            {
              invoice_time: invoiceTimeThree ? parseTime(invoiceTimeThree, '{y}-{m}-{d}') : '',
              collection_time: collectionTimeThree ? parseTime(collectionTimeThree, '{y}-{m}-{d}') : '',
              invoice_delta: invoiceTimeFirst ? Math.round((invoiceTimeFirst - estimatedDeliveryTime) / 86400000) : '',
              collectionDelta: collectionTimeThree ? Math.round((collectionTimeThree - estimatedDeliveryTime) / 86400000) : '',
              amount: this.invoiceData.amountFirst
            }
            ]
            console.log('infos', infos)
            params.infos = infos
          } else if (this.formruleType === 'timeRule') {
            const invoiceTime = typeof this.invoiceData.invoiceTime === 'string' ? (new Date(this.invoiceData.invoiceTime)).getTime() : this.invoiceData.invoiceTime.getTime()
            const collectionTime = typeof this.invoiceData.collectionTime === 'string' ? (new Date(this.invoiceData.collectionTime)).getTime() : this.invoiceData.collectionTime.getTime()
            let infos = [{
              invoice_time: parseTime(invoiceTime, '{y}-{m}-{d}'),
              collection_time: parseTime(collectionTime, '{y}-{m}-{d}'),
              invoice_delta: Math.round((invoiceTime - estimatedDeliveryTime) / 86400000),
              collection_delta: Math.round((collectionTime - estimatedDeliveryTime) / 86400000),
              amount: this.advanceData.total_amount
            }]
            params.infos = infos
            console.log('innfos', infos)
          } else {
            const invoiceDeltaTime = estimatedDeliveryTime + this.invoiceData.invoiceDelta * 86400000
            const collectionDelta = estimatedDeliveryTime + this.invoiceData.collectionDelta * 86400000
            let infos = [{
              invoice_time: parseTime(invoiceDeltaTime, '{y}-{m}-{d}'),
              collection_time: parseTime(collectionDelta, '{y}-{m}-{d}'),
              invoice_delta: this.invoiceData.invoiceDelta,
              collection_delta: this.invoiceData.collectionDelta,
              amount: this.advanceData.total_amount
            }]
            params.infos = infos
            console.log('innfos', infos)
          }
          await createEstimatedAdvance(params)
          this.closeDrawer()
        }
      })
    },
    closeDrawer () {
      this.loading = false
      this.invoiceRadio = 'single' // 是否为多笔订单 single 单 More 多
      this.invoiceDate = 'time'  // 选择的时间方式
      this.timeType = 'standard'
      this.estimatedDeliveryTime = ''
      this.invoiceData = {
        invoiceTime: '',
        collectionTime: '',
        invoiceTimeFirst: '',
        collectionTimeFirst: '',
        amountFirst: 0,
        invoiceTimeSecond: '',
        collectionTimeSecond: '',
        amountSecond: 0,
        invoiceTimeThree: '',
        collectionTimeThree: '',
        amountThree: 0,
      },
        this.$refs.drawer.closeDrawer()
    }
  }
}
</script>
<style scoped>
el-drawer {
  overflow: scroll;
}
.el-form {
  width: 70%;
  margin: auto;
}
.el-form-item {
  text-align: left;
}
.gray {
  padding-left: 30px;
  background-color: rgb(179, 204, 243);
  width: 100%;
}
.inputClass {
  width: 50%;
  margin-right: 10px;
}
</style>